import { render, staticRenderFns } from "./Autorizador.vue?vue&type=template&id=84db8cfc"
import script from "./Autorizador.vue?vue&type=script&lang=js"
export * from "./Autorizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports